export const SGUAI_DISPLAY_PROFILES = [
  {
    id: "c3-48x12",
    name: "C3 / C3R",
    width: 48,
    height: 12,
    models: ["SGUAI-C3", "SGUAI-C3R"],
  },
  {
    id: "c5-36x12",
    name: "C5 / C5R",
    width: 36,
    height: 12,
    models: ["SGUAI-C5", "SGUAI-C5R"],
  },
  {
    id: "c6-24x24",
    name: "C6 / C6 Pro",
    width: 24,
    height: 24,
    models: ["SGUAI-C6", "SGUAI-C6 Pro"],
  },
];

export const publicDisplayProfile = ({models, ...profile}) => ({...profile});

export const findDisplayProfile = (profiles, profileId) => (
  profiles.find((profile) => profile.id === profileId) ?? profiles[0]
);

export const findDisplayProfileForDevice = (profiles, deviceName) => (
  profiles.find((profile) => profile.models?.includes(deviceName)) ?? null
);
